module.exports = __webpack_public_path__ + "img/tu.384b4cc8.png";